import React from 'react';
import { BookOpen, GraduationCap, Target, TrendingUp, Clock, Users } from 'lucide-react';

function LearnWithUsSection() {
    const features = [
        {
            icon: <BookOpen size={24} />,
            title: "Comprehensive Curriculum",
            description: "Covering all aspects of video production from basic to advanced"
        },
        {
            icon: <GraduationCap size={24} />,
            title: "Expert Instructors",
            description: "Learn from industry professionals with 20+ years experience"
        },
        {
            icon: <Target size={24} />,
            title: "Practical Learning",
            description: "Hands-on projects and real-world case studies"
        },
        {
            icon: <TrendingUp size={24} />,
            title: "Career Growth",
            description: "Skills that accelerate your career in media industry"
        }
    ];

    return (
        <div className="bg-gradient-to-b from-emerald-50 to-green-50 py-16 md:py-24">
            <div className="max-w-7xl mx-auto px-4">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left Content */}
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <span className="inline-block px-4 py-2 bg-gradient-to-r from-emerald-200 to-green-200 text-emerald-800 rounded-full text-sm font-medium">
                                Coming Soon
                            </span>
                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                                Let's{' '}
                                <span className="bg-gradient-to-r from-emerald-600 to-green-600 bg-clip-text text-transparent">
                                    Learn With Us
                                </span>
                            </h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                Knowledge & Hard Work accelerate you towards success & give you Name, 
                                Fame & Money. So let's learn and earn with us.
                            </p>
                            <p className="text-gray-600">
                                Something dynamic and mind blowing for you coming soon. (Online & offline learning)
                            </p>
                        </div>

                        <div className="inline-flex items-center gap-4 px-6 py-3 bg-white rounded-full shadow-lg">
                            <div className="flex items-center gap-2">
                                <Clock className="text-emerald-600" size={20} />
                                <span className="font-semibold text-gray-900">COMING SOON!</span>
                            </div>
                            <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {features.map((feature, index) => (
                                <div key={index} className="bg-white/80 backdrop-blur-sm rounded-xl p-5 border border-emerald-100">
                                    <div className="flex items-start gap-4">
                                        <div className="p-2 bg-gradient-to-r from-emerald-500 to-green-500 rounded-lg">
                                            <div className="text-white">{feature.icon}</div>
                                        </div>
                                        <div>
                                            <h4 className="font-semibold text-gray-900 mb-1">{feature.title}</h4>
                                            <p className="text-sm text-gray-600">{feature.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Right Content */}
                    <div className="relative">
                        <div className="bg-gradient-to-br from-emerald-600 to-green-700 rounded-3xl p-8 text-white">
                            <div className="space-y-6">
                                <div className="text-center">
                                    <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-6">
                                        <GraduationCap size={32} />
                                    </div>
                                    <h3 className="text-2xl font-bold mb-4">What You'll Learn</h3>
                                </div>
                                
                                <div className="space-y-4">
                                    <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl">
                                        <Users size={24} />
                                        <div>
                                            <h4 className="font-semibold">Industry Insights</h4>
                                            <p className="text-sm opacity-90">From professionals with decades of experience</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl">
                                        <Target size={24} />
                                        <div>
                                            <h4 className="font-semibold">Practical Skills</h4>
                                            <p className="text-sm opacity-90">Hands-on training on real projects</p>
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl">
                                        <TrendingUp size={24} />
                                        <div>
                                            <h4 className="font-semibold">Career Development</h4>
                                            <p className="text-sm opacity-90">Guidance for industry placement</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-6 border-t border-white/20">
                                    <div className="text-center">
                                        <p className="mb-4">Be the first to know when we launch!</p>
                                        <div className="flex gap-3">
                                            <input
                                                type="email"
                                                placeholder="Enter your email"
                                                className="flex-1 px-4 py-3 rounded-lg text-gray-900 placeholder-gray-500"
                                            />
                                            <button className="px-6 py-3 bg-white text-emerald-700 font-semibold rounded-lg hover:bg-gray-100 transition-colors">
                                                Notify Me
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Decorative elements */}
                        <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-emerald-200 to-green-200 rounded-full blur-3xl opacity-50"></div>
                        <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-emerald-100 to-green-100 rounded-full blur-3xl opacity-30"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LearnWithUsSection;